module.exports = __webpack_public_path__ + "static/img/audioOn2.285844d2.png";